import React from 'react'
import Layout from '@components/layout'
import { getAllDocSlugs, getBlogPost } from '@lib/api'
import { websiteLocales } from '@lib/routes'
import { friendlyDate } from '@lib/helpers'
import { Module } from '@modules/index'

const BlogPage = ({ data }) => {
  const { site, page } = data

  return (
    <Layout site={site} page={page}>
      <section className="section">
        <div className="section--content">
          <h1>{page.title}</h1>
          <div className="blog--date">{friendlyDate(page._createdAt)}</div>
          {friendlyDate(page._updatedAt) !== friendlyDate(page._createdAt) ? (
            <div className="blog--date">
              Last update: {friendlyDate(page._updatedAt)}
            </div>
          ) : null}
        </div>
      </section>

      {page.modules?.map((module, key) => (
        <Module key={key} uniqueId={key} module={module} />
      ))}
    </Layout>
  )
}

export async function getStaticProps({ params, preview, previewData, locale }) {
  const pageData = await getBlogPost({
    slug: params.slug,
    locale,
    preview: {
      active: preview,
      token: previewData?.token,
    },
  })

  const notFound = !pageData.page

  return {
    props: {
      data: pageData,
    },
    revalidate: 60,
    notFound,
  }
}

export async function getStaticPaths() {
  const all = await getAllDocSlugs('post')

  return {
    paths:
      all
        ?.map((collection) => {
          return websiteLocales.map((locale) => ({
            params: {
              slug: collection.slug,
            },
            locale,
          }))
        })
        .flat() || [],
    fallback: 'blocking',
  }
}

export default BlogPage
